import React from 'react';
import {defineMessages} from 'react-intl';
import type {DateRangeFilterValue, FilterGroupNewFilter, FilterProps, FiltersProps} from '@igp/shared/components/filter';
import {DateRangeFilter, FilterGroupNew} from '@igp/shared/components/filter';
import type {CountryFilterSharedProps} from '@igp/shared/features/country';
import {CountryFilter} from '@igp/shared/features/country';
import {useLocale} from '@igp/shared/localization';
import type {Locale} from '@igp/shared/style';
import type {EntityType} from '@models';

import {firstAvailableDate} from '../constants';
import type {CountryLevelPartnerReportFilterName, CountryLevelPartnerReportFilterViewModel} from '../types';

const localized = defineMessages({
    countries: {
        id: 'CountryLevelPartnerReportFilters_countries',
        defaultMessage: 'Country',
    },
});

type CountryLevelPartnerReportFiltersProps = FiltersProps<CountryLevelPartnerReportFilterViewModel, CountryLevelPartnerReportFilterName> &
    CountryFilterSharedProps<EntityType>;

export function CountryLevelPartnerReportFilters({countryEntity, countryConfig, ...props}: CountryLevelPartnerReportFiltersProps) {
    const {locale} = useLocale();
    const availableDateRangeForSelection = {from: firstAvailableDate.toDate()};

    const filters: FilterGroupNewFilter<CountryLevelPartnerReportFilterViewModel, CountryLevelPartnerReportFilterName>[] = [
        {
            filterName: 'countries',
            modelField: 'countries',
            component: (props: FilterProps<string[]>) => (
                <CountryFilter inputLabel={localized.countries} countryEntity={countryEntity} config={countryConfig} {...props} />
            ),
        },
        {
            filterName: 'date',
            modelField: 'date',
            component: (props: FilterProps<DateRangeFilterValue>) => (
                <DateRangeFilter
                    {...props}
                    availableDateRangeForSelection={availableDateRangeForSelection}
                    width="full"
                    locale={locale as Locale}
                    filterEntity="report"
                    hasInputTooltip={true}
                />
            ),
        },
    ];

    return <FilterGroupNew mode="update-on-change" allFilters={filters} {...props} />;
}
